import getnet from './getnet'
import stripe from './stripe'
import santander from './santander'

export default {
  namespaced: true,
  modules: {
    getnet,
    stripe,
    santander,
  },
  getters: {},
  state: {},
  mutations: {},
  actions: {},
}
